import {
    Box,
    Button,
    Container,
    FormHelperText,
    InputLabel,
    TextField,
    Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { Autocomplete } from "@mui/material";
import Config from "Config";
import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { getUserAgent, isEmpty, isNotEmpty } from "../../Utils";
import Header from "../../component/Header/Header";
import PortalNavbar from "../../component/PortalNavbar/PortalNavbar";
import CustomTextField from "../../inputComponent/CustomTextField/CustomTextField";
import { resetRedirectTo, setUserRole, userLogin } from "../../redux/action";
import { getRedirectUrl, getToken, getUserRole } from "../../redux/selector";
import ErrorMsg from "../ErrorMsg/ErrorMsg";
import "./LoginPage.scss";

const useStyles = makeStyles({
    root: {
        width: "85%",
        height: "100%",
        margin: "6px 100px 0px 50px",
        flex: 1,
    },
    rootMobile: {
        margin: "6px 0px 0px 0px",
        flex: 1,
    },
    eye: {
        transform: "translate(10px)",
    },
});

function LoginSSLO() {
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [visible, setVisible] = useState(false);
    const [loginData, setLoginData] = useState(null);
    const [options, setOptions] = useState([]);
    const { register, handleSubmit, watch, formState, setError, setValue } =
        useForm({
            defaultValues: {
                username: "",
                password: "",
            },
            mode: "onBlur",
        });
    let option = [];
    const token = useSelector(getToken());
    const [cookies, setCookie] = useCookies(["token"]);
    const role = useSelector(getUserRole());
    useEffect(() => {
        // when login success
        if (isNotEmpty(token) && role !== "notLoggedIn") {
            // navigate("/main");
            setCookie("token", token, {
                path: `${Config.CONTENT_PATH}`,
                maxAge: 3600,
                secure: true,
            });
        }
    }, [token]);

    const onFetchError = () => {
        setError("password", {
            type: "invalid",
            message: "loginError",
        });
    };
    const redirectUrl = useSelector(getRedirectUrl());
    const [searchParams, setSearchParams] = useSearchParams();
    const redirect = searchParams.get("redirect");

    const onLogin = () => {
        if (isEmpty(redirectUrl)) {
            if (isEmpty(redirect)) {
                navigate("/main");
            } else {
                navigate(redirect);
            }
        } else {
            dispatch(resetRedirectTo());
            navigate(redirectUrl);
        }
    };

    const onSubmit = (formData) => {
        window.grecaptcha.ready(function () {
            window.grecaptcha
                .execute("6LeWvVwdAAAAAI9JwB5OcndiYHiCA_LCISNCmTiM", {
                    action: "submit",
                })
                .then(function (token) {
                    formData[`response`] = token;
                    // Send form value as well as token to the server
                    dispatch(userLogin(formData, onFetchError)).then(
                        (result) => {
                            console.log("SSLOLogin:" + JSON.stringify(result));
                            let url = result?.redirectUrl;
                            if (url != null) {
                                dispatch(setUserRole(result?.role));
                                navigate(url); //changePassword
                            } else if (result?.token != null) {
                                onLogin();
                                dispatch(setUserRole(result?.role));
                            } else {
                                const errMsgList = {
                                    ACCOUNT_LOCKED: "accountLocked",
                                };
                                if (
                                    isNotEmpty(result?.msg) &&
                                    isNotEmpty(errMsgList?.[result?.msg])
                                ) {
                                    setError("password", {
                                        type: "invalid",
                                        message: errMsgList[result.msg],
                                    });
                                }
                            }
                        }
                    );
                });
        });
    };

    const onClickVisible = () => {
        if (visible) {
            setVisible(false);
        } else {
            setVisible(true);
        }
    };
    const errors = formState.errors;

    useEffect(() => {
        fetch("/eformss/organizations/getSSLOOrg")
            .then((res) => {
                //this localhost saved all the data from Data.json!!
                return res.json();
            })
            .then((data) => {
                setLoginData(data);
                console.log(data);
                return data;
            });
    }, []);

    const [optionLang, setOptionLang] = useState(i18n.language);

    // useEffect(()=>{

    //     switch(i18n.language){
    //         case "en":
    //         console.log("en")
    //         setOptionLang("en")
    //         break;

    //         case "tc":
    //         console.log("tc")
    //         setOptionLang("tc")
    //         break;

    //         case "sc":
    //         console.log("sc")
    //         setOptionLang("sc")
    //         break;
    //     }

    // },[i18n.language])

    const handleCheckEmail = (e) => {
        if (loginData && e.target && e.target.value) {
            var arr = loginData.filter(function (el) {
                return el.email === e.target.value;
            });

            if (arr.length > 0) {
                arr[0].subCategories.forEach((item, index) => {
                    option.push({
                        id: index,
                        //label:item[i18n.language] ? item[i18n.language] : item['tc'],
                        tc: item["tc"],
                        sc: item["sc"] ? item["sc"] : item["tc"],
                        en: item["en"],
                        key: item.key,
                    });
                });
            } else {
                setValue("ssloOrgKey", null);
            }
            setOptions(option);
        }
    };

    const changeOrganisation = (value) => {
        setValue(
            "ssloOrgKey",
            options.length && value && value.key !== "" ? value.key : null
        );
    };

    return (
        <Container maxWidth="md">
            <Header
                headerTitle={t("common.sideNavList.login")}
                className="header"
            ></Header>
            <Box className="container">
                <PortalNavbar aside className="drawer" />
                <Box className="main">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Box
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                flexDirection: "column",
                                height: "100%",
                            }}
                        >
                            <Typography variant="h5" component="h1">
                                SSLO {t("common.sideNavList.login")}
                                <br />
                                <br />
                            </Typography>
                            <CustomTextField
                                label={t("common.portal.username")}
                                required={false}
                                style={{ width: "45%" }}
                                inputProps={register("username", {
                                    validate: {
                                        valid: (value) =>
                                            value.includes("@") ||
                                            "invalidEmail",
                                        //(i18n.language==="tc"?"請輸入有效的電郵。":i18n.language==="sc"?"请输入有效的电邮。":"Please enter a valid email." )
                                    },
                                    required: "emptyEmail",
                                    //i18n.language==="tc"?"電郵不能為空。":i18n.language==="sc"?"电邮不能为空。":"Email cannot be empty."
                                })}
                                type="email"
                                onChange={(e) => handleCheckEmail(e)}
                            />

                            {/* ADD dropdown */}
                            {loginData &&
                                options.length > 0 &&
                                watch("username") != "" && (
                                    <>
                                        <Box
                                            style={{
                                                width: "45%",
                                                padding: "5px 0",
                                            }}
                                        >
                                            <InputLabel for="inputOrg">
                                                {t(
                                                    "common.portal.organization"
                                                )}
                                            </InputLabel>
                                            <Autocomplete
                                                id="inputOrg"
                                                options={options}
                                                getOptionLabel={(option) =>
                                                    option[i18n.language]
                                                }
                                                style={{ width: "100%" }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        variant="standard"
                                                    />
                                                )}
                                                onChange={(e, newValue) => {
                                                    changeOrganisation(
                                                        newValue
                                                    );
                                                }}
                                            />
                                        </Box>
                                    </>
                                )}

                            {errors?.username?.message && (
                                <FormHelperText>
                                    <ErrorMsg
                                        message={t(
                                            "common.login.error." +
                                                errors?.username?.message
                                        )}
                                    />
                                </FormHelperText>
                            )}
                            <CustomTextField
                                label={t("common.portal.password")}
                                required={false}
                                style={{ width: "45%" }}
                                unit={
                                    visible === true ? (
                                        <Button
                                            onClick={onClickVisible}
                                            disableRipple={true}
                                            className={classes.eye}
                                            aria-label="password"
                                        >
                                            <VisibilityOffIcon
                                                style={{ color: "gray" }}
                                            />
                                        </Button>
                                    ) : (
                                        <Button
                                            onClick={onClickVisible}
                                            disableRipple={true}
                                            className={classes.eye}
                                            aria-label="password"
                                        >
                                            <VisibilityIcon
                                                style={{ color: "gray" }}
                                            />
                                        </Button>
                                    )
                                }
                                type={visible ? null : "password"}
                                inputProps={register("password", {
                                    required: "emptyPassword",
                                    //i18n.language==="tc"?"密碼不能為空。":i18n.language==="sc"?"密码不能为空。":"Password can not be blank.",
                                })}
                            />
                            {errors?.password?.message && (
                                <ErrorMsg
                                    message={t(
                                        "common.login.error." +
                                            errors?.password?.message
                                    )}
                                />
                            )}
                            <br />
                            <br />
                            <Box>
                                <Button
                                    className="buttons"
                                    variant="contained"
                                    color="primary"
                                    type="submit"
                                    style={{ marginRight: "10px" }}
                                    data-action="submit"
                                    data-sitekey="6LeWvVwdAAAAAI9JwB5OcndiYHiCA_LCISNCmTiM"
                                    data-callback="onSubmit"
                                >
                                    {t("common.sideNavList.login")}
                                </Button>
                                <Button
                                    className="buttons"
                                    variant="contained"
                                    color="primary"
                                    style={{ marginLeft: "10px" }}
                                    component={Link}
                                    to="/forgotPassword"
                                >
                                    {t("common.portal.forgotPassword")}
                                </Button>
                            </Box>
                            <div
                                className={
                                    [
                                        "Windows Phone",
                                        "Android",
                                        "iOS",
                                    ].includes(getUserAgent())
                                        ? "general-mobile-page"
                                        : "general-page"
                                }
                            >
                                {t("reCaptcha.lng")}
                                <a
                                    href={t("reCaptcha.policyLink")}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {t("reCaptcha.priPolicy")}
                                </a>{" "}
                                {t("reCaptcha.and")}
                                <a
                                    href={t("reCaptcha.termsLink")}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {t("reCaptcha.terService")}
                                </a>{" "}
                                {t("reCaptcha.apply")}
                            </div>
                        </Box>
                    </form>
                </Box>
            </Box>
        </Container>
    );
}
export default LoginSSLO;
